import * as actionTypes from 'constants/Payments';

export function setPaymentSelected(paymentSelected: string) {
  return {
    type: actionTypes.SET_PAYMENT_SELECTED,
    payload: paymentSelected,
  };
}
